// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-footer {\n  margin-top: -40px;\n  background: black;\n  padding: 10px 20px;\n  text-align: right;\n}\n.sticky-footer a,\n.sticky-footer a:visited,\n.sticky-footer a:hover {\n  color: white;\n  margin-left: 10px;\n  text-decoration: none;\n  font-size: 0.85em;\n}\n", ""]);
// Exports
module.exports = exports;
